import { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const LdsOptionSelectorItem = forwardRef(function LdsOptionSelectorItem(
  {
    id,
    name,
    value,
    label,
    required = false,
    disabled = false,
    className,
    ...rest
  },
  ref
) {
  return (
    <span
      className={cn(
        'lds-option-selector-item',
        'col-12',
        'col-md',
        {
          disabled,
        },
        className
      )}
    >
      <input
        className={cn(
          'lds-option-selector',
          {
            disabled,
          }
        )}
        id={`${id}-optionSelector`}
        type="radio"
        name={name}
        value={value}
        disabled={disabled}
        required={required}
        {...rest}
        ref={ref}
      />
      <label
        className="lds-option-selector-label"
        htmlFor={`${id}-optionSelector`}
      >
        {label}
      </label>
    </span>
  );
});

LdsOptionSelectorItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default LdsOptionSelectorItem;
